import qs from 'query-string';
import { useLocation } from 'react-router-dom';

export type QueryParamStateValue = string | number | boolean | null | (string | number | boolean | null)[];

const ParseOptions = {
  parseNumbers: true,
  parseBooleans: true,
  arrayFormat: 'comma' as const,
  skipNull: true,
  skipEmptyString: true,
};
export function useQueryParams<Params extends { [K in keyof Params]: QueryParamStateValue }>(): Params {
  const location = useLocation();

  const queryParamsMap = qs.parse(location.search, ParseOptions) as Params;

  return queryParamsMap;
}
